// Score options (1–5, no labels)
export const SCORE_OPTIONS = [1, 2, 3, 4, 5];

// Shared years range (2019 -> current year)
export const getAvailableYears = (startYear = 2019) => {
    const currentYear = new Date().getFullYear();
    const start = Number.isFinite(startYear) ? startYear : 2019;
    const len = Math.max(1, currentYear - start + 1);
    return Array.from({ length: len }, (_, i) => start + i);
};

// Mapping of fields per group
export const GROUP_FIELDS = [
    ['g1_1', 'g1_2', 'g1_3', 'g1_4'],
    ['g2_1', 'g2_2', 'g2_3', 'g2_4'],
    ['g3_1', 'g3_2', 'g3_3', 'g3_4'],
    ['g4_1', 'g4_2', 'g4_3', 'g4_4'],
    ['g5_1', 'g5_2', 'g5_3', 'g5_4'],
    ['g6_1', 'g6_2', 'g6_3', 'g6_4'],
    ['g7_1', 'g7_2', 'g7_3', 'g7_4'],
    ['g8_1', 'g8_2', 'g8_3', 'g8_4'],
];

// For departments other than "Direção"
export const GROUPS_DEFAULT = [
    {
        title: 'Inovação',
        questions: [
            '1. Antevê oportunidades e orienta os recursos da empresa para desenvolver novos projetos.',
            '2. Toma decisões com potencial de lucro para a empresa.',
            '3. Propõe soluções de valor para os clientes.',
            '4. Controla a implementação dos novos projetos ou processos.',
        ],
    },
    {
        title: 'Qualidade',
        questions: [
            '1. Decide em função das normas e princípios da Qualidade definidos pela empresa.',
            '2. Implementa soluções de melhoria nos processos em que intervém.',
            '3. Executa as atividades de acordo com os referênciais normativos em vigor.',
            '4. Informa das ocorrências ou não conformidades identificadas no decorrer da sua atividade.',
        ],
    },
    {
        title: 'Orientação para o cliente',
        questions: [
            '1. Revela empatia, respeito e disponibilidade na relação com o cliente.',
            '2. Antecipa as necessidades e expectativas dos clientes.',
            '3. Garante o cumprimentos de todos os compromissos assumidos com o cliente incluindo a resolução dos problemas.',
            '4. Utiliza o feedback dos clientes como um fator de melhoria contínua.',
        ],
    },
    {
        title: 'Capacidade de organização',
        questions: [
            '1. Planeia e executa as suas tarefas, em função de uma hierarquia de objetivos bem definida.',
            '2. Desenvolve as suas tarefas de forma lógica, otimizando o consumo de tempo e recursos.',
            '3. Mantém os locais de trabalho, físico e virtual, organizados.',
            '4. Promove novas formas de organização com vista a maior eficácia no trabalho.',
        ],
    },
    {
        title: 'Orientaçõo para os resultados',
        questions: [
            '1. Grau de cumprimento dos objetivos estratégicos e operacionais fixados.',
            '2. Mostra motivação para superar os objetivos do seu trabalho.',
            '3. É capaz de desbloquear obstáculos relacionados com o seu trabalho.',
            '4. Introduz correções aos planos com vista a melhorar e em alcançar padrões elevados de excelência.',
        ],
    },
    {
        title: 'Gestão/ Coordenação de projetos',
        questions: [
            '1. Define os recursos e meios necessários à execução de um ou mais projetos.',
            '2. Implementa e/ou acompanha as atividades necessárias ao desenvolvimento dos projetos.',
            '3. Controla os prazos de execução e suas condicionantes.',
            '4. Resolve os problemas e gere o feedback dos clientes.',
        ],
    },
    {
        title: 'Capacidade técnica',
        questions: [
            '1. Executa e ajusta as atividades relativas aos projetos.',
            '2. Identifica as melhores práticas e generaliza esse conhecimento para outros projetos.',
            '3. Domina e implementa conhecimento especifico do projeto.',
            '4. Mantém atualizada toda a informação referente a atividades/projetos.',
        ],
    },
    {
        title: 'Conhecimento, informação e normas',
        questions: [
            '1. Interpreta e atualiza conhecimento específico, legislação e normas.',
            '2. Aplica-os de forma adequada.',
            '3. Capacidade de elaborar pareceres técnicos.',
            '4. Garantir a confidencialidade e segurança de toda a informação, interna e externa.',
        ],
    },
];

// For "Direção" department
export const GROUPS_DIRECAO = [
    {
        title: 'Inovação',
        questions: [
            '1. Antevê oportunidades e orienta os recursos da empresa para desenvolver novos projetos.',
            '2. Toma decisões com potencial de lucro para a empresa.',
            '3. Propõe soluções de valor para os clientes.',
            '4. Controla a implementação dos novos projetos ou processos.',
        ],
    },
    {
        title: 'Qualidade',
        questions: [
            '1. Decide em função das normas e princípios da Qualidade definidos pela empresa.',
            '2. Implementa soluções de melhoria nos processos em que intervém.',
            '3. Executa as atividades de acordo com os referências normativos em vigor.',
            '4. Informa das ocorrências ou não conformidades identificadas no decorrer da sua atividade.',
        ],
    },
    {
        title: 'Compromisso',
        questions: [
            '1. Realiza as suas tarefas dentro do que lhe foi proposto.',
            '2. Assume prontamente as consequências das suas ações e decisões independentemente dos resultados apresentados.',
            '3. Hierarquiza as atividades e objetivos em função da sua contribuição para os resultados centrais da organização.',
            '4. Mostra-se disponível para concretizar com sucesso os seus objetivos e os da empresa.',
        ],
    },
    {
        title: 'Orientação para o cliente',
        questions: [
            '1. Revela empatia, respeito e disponibilidade na relação com o cliente.',
            '2. Antecipa as necessidades e expectativas dos clientes.',
            '3. Garante o cumprimentos de todos os compromissos assumidos com o cliente incluindo a resolução dos problemas.',
            '4. Utiliza o feedback dos clientes como um fator de melhoria contiínua.',
        ],
    },
    {
        title: 'Gestão de equipa',
        questions: [
            '1. Orienta a equipa para ações coerentes com os valores e a estratégia da empresa.',
            '2. Incute na equipa a eficiência e a eficácia das atividades e tarefas.',
            '3. Encoraja e reconhece o contributo dos elementos da equipa.',
            '4. Motiva a equipa para o sucesso dos resultados.',
        ],
    },
    {
        title: 'Planeamento',
        questions: [
            '1. Planeia a atividade de acordo com os objetivos definidos.',
            '2. Define prioridades tendo em conta os objetivos a alcançar e os recursos existentes.',
            '3. Acompanha, controla e avalia a execução dos projetos e atividades assegurando o seu desenvolvimento e a sua realização de acordo com os prazos e custos definidos.',
            '4. Revê e ajusta o planeamento efetuado, mantendo-o atualizado e adaptando-o a alterações e circunstâncias imprevistas.',
        ],
    },
    {
        title: 'Rigor',
        questions: [
            '1. É capaz de se concentrar na análise crítica da informação recebida.',
            '2. É exigente com a qualidade do trabalho que desenvolve.',
            '3. Perante um problema ou anomalia analisa exaustivamente os dados e toma as iniciativas necessárias para a correção de eventuais erros.',
            '4. Assegura escrupulosamente o detalhe/pormenor de todos os trabalhos que executa.',
        ],
    },
    {
        title: 'Orientação para os resultados',
        questions: [
            '1. Grau de cumprimento dos objetivos estratégicos e operacionais fixados.',
            '2. Mostra motivação para superar os objetivos do seu trabalho.',
            '3. É capaz de desbloquear obstáculos relacionados com o seu trabalho.',
            '4. Introduz correções aos planos com vista a melhorar e em alcançar padrões elevados de excelência.',
        ],
    },
];

export const getGroupsForDepartment = (departmentName) =>
    departmentName === 'Direção' ? GROUPS_DIRECAO : GROUPS_DEFAULT;

export const buildInitialForm = (assessment) => {
    const base = {};
    GROUP_FIELDS.flat().forEach((field) => {
        const val = assessment?.[field];
        base[field] = Number.isFinite(val) ? val : null;
    });
    return base;
};

export const formatScore = (value) => {
    if (typeof value !== 'number') return '—';
    return value.toFixed(1).replace('.', ',');
};